import { requestGet, requestPost } from '@/utils/request';

/**
 * === 动态管理 ===
 */
// 获取批次基础信息
export function getBaseInfo(batchId: string) {
  return requestGet(`/v2/camp/api/frontend/manage/batch/${batchId}`, {});
}

// 更新动态精选
export function postSelected(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/selected/${batchId}`, params);
}

// 更新动态隐藏
export function postHide(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/hide/${batchId}`, params);
}

/**
 * === 学员管理 ===
 */
// 分页指定批次学员
export function studentPage(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/student/page/${batchId}`, params);
}

// 创建学员
export function createStudent(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/student/create/${batchId}`, params);
}

// 删除学员
export function removeStudent(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/student/remove/${batchId}`, params);
}

/**
 * === 学员管理 - 学员日志信息 ===
 */
//列举批次各节点学习日志
export function listNodeLog(batchId: string, signUpId: string) {
  return requestGet(
    `/v2/camp/api/frontend/manage/student/log/list/node/${batchId}?signUpId=${signUpId}`,
    {},
  );
}
// 列举批次各节点视频观看日志
export function listVideoLog(batchId: string, signUpId: string) {
  return requestGet(
    `/v2/camp/api/frontend/manage/student/log/list/video/${batchId}?signUpId=${signUpId}`,
    {},
  );
}

// 分页批次各节点学分日志
export function pageScoreLog(batchId: string, params: any) {
  return requestPost(`/v2/camp/api/frontend/manage/student/log/page/score/${batchId}`, params);
}

// 列举领取奖励日志
export function listRewardLog(batchId: string, uid: number) {
  return requestGet(
    `/v2/camp/api/frontend/manage/student/log/list/reward/${batchId}?uid=${uid}`,
    {},
  );
}
/**
 * === 数据统计 ===
 */
export function getStatisticData(batchId: string) {
  return requestGet(`/v2/camp/api/frontend/manage/statistic/data/${batchId}`, {});
}
